// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "device/authorize",
    name: "device.authorize",
    meta: {
      title: "授权",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./deviceAuthorize.vue"),
  },
  {
    path: "device/selectAuth",
    name: "device.selectAuth",
    meta: {
      title: "选择云手机",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./selAuthDevice.vue"),
  },
  {
    path: "security/code",
    name: "security.code",
    meta: {
      title: "安全密码",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./securityCode.vue"),
  },
];
